import React from 'react'
import styled from 'styled-components'
import { useMediaQuery } from '@mui/material';
import { addTheme } from '../../../style/addTheme';
import { KAKAO_LINK } from '../../../api/config';
import { Center, Row } from '../../../style/basic/commonStyle';
import { useDispatch } from 'react-redux';
import { globalAirportReset } from '../../../store/common/globalAirport';
import { globalParkingReset } from '../../../store/common/globalParking';

export default function ServiceBtnPart({ reservationAction }: any) {
    const mediaQuery = useMediaQuery(addTheme.media.s);
    const dispatch = useDispatch();

    const kakaoClick = () => {
        window.open(KAKAO_LINK);
    }

    const reservationClick = () => {
        if (reservationAction) {
            dispatch(globalAirportReset());
            dispatch(globalParkingReset());
            reservationAction();
        }
    }

    return (
        <>
            {
                mediaQuery ?
                    <MoWrap>
                        <KakaoWrap onClick={kakaoClick}>카톡 상담하기</KakaoWrap>
                        <MoNowWrap onClick={reservationClick}>지금 바로 예약하기</MoNowWrap>
                    </MoWrap> :
                    <PcWrap>
                        <PcKakaoWrap onClick={kakaoClick}>카톡 상담하기</PcKakaoWrap>
                        <PcNowWrap onClick={reservationClick}>지금 바로 예약하기</PcNowWrap>
                    </PcWrap>
            }
        </>
    )
}

const PcWrap = styled(Row)`
    position: fixed;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    gap: 10px;
    z-index: 48;
`;

const MoWrap = styled(Row)`
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 20px;
    width: 100%;
    flex-direction: column;
    align-items: end;
    gap: 10px;
    z-index: 48;
`;

const KakaoWrap = styled(Center)`
    background-color: ${addTheme.kakaoColor};
    color: #3C1E1E;
    padding: 10px 18px;
    border-radius: 100px;
    font-weight: 600;
    cursor: pointer;
`;

const PcKakaoWrap = styled(KakaoWrap)`
    width: 240px;
    height: 56px;
    font-size: 22px;
`;
const NowWrap = styled(Center)`
    background-color: #000;
    color: #fff;
    padding: 13px 22px;
    border-radius: 100px;
    font-weight: 600;
    cursor: pointer;
`;

const PcNowWrap = styled(NowWrap)`
    width: 240px;
    height: 56px;
    font-size: 22px;
`;

const MoNowWrap = styled(NowWrap)`
    width: 100%;
    text-align: center;
    border-radius: 8px;
`;